/**
 * QUIET AT NIGHT, on the console's side (Hamzah, 2026-10-09: "a solar site that goes quiet at
 * night shouldn't raise comm loss / Silent; say Quiet at night instead"). The server decides
 * (lumen-be `telemetry/quiet-night.ts`, the same rule the ingest's silence sweep applies to its
 * `comm_loss` row); every screen that turns `silent` into a fault asks here first, so the word,
 * the colour and the count change together.
 *
 * Plain, never a warning: the site is asleep, not broken. Once its silence outlasts the window
 * after sunrise the server stops saying so and the old "Silent" comes back on its own.
 */
import type { SiteHealth } from '@/lib/api/types';

/** True when a site reads `silent` only because it is night there. */
export function isQuietAtNight(h: Pick<SiteHealth, 'reportingState' | 'quietAtNight'> | null | undefined): boolean {
  return h?.reportingState === 'silent' && h.quietAtNight === true;
}

/** "Quiet at night, last reported 11:29 PM" — the time in the site's zone when it is known. */
export function quietAtNightLine(lastSeenAt: string | null, timeZone?: string): string {
  const at = lastSeenAt ? Date.parse(lastSeenAt) : Number.NaN;
  if (!Number.isFinite(at)) return 'Quiet at night';
  const time = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    ...(timeZone ? { timeZone } : {}),
  }).format(at);
  return `Quiet at night, last reported ${time}`;
}
